import { config } from '../config';

import { authHeader, parseJwt } from '../helpers';

export const apiService = {
  login,
  logout,
  register,
  reset,
  getAccount,
  patchAccount,
  getReservations,
  deleteReservation,
  patchReservation,
  postReservation,
  searchClients,
  loadPlanning,
  loadCourts,
  loadConfig
};

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  };

  return fetch(`${config.apiUrl}/auth`, requestOptions)
    .then(handleResponse)
    .then(user => {
      user.data = parseJwt(user.access_token);
      localStorage.setItem('user', JSON.stringify(user));

      return user;
    });
}

function logout() {
  localStorage.removeItem('user');
}

function register(user) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/registration`, requestOptions).then(handleResponse);
}

function reset(user) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/reset`, requestOptions).then(handleResponse);
}

function getAccount() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/me/account`, requestOptions).then(handleResponse);
}

function patchAccount(user) {
  const requestOptions = {
    method: 'PATCH',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/me/account`, requestOptions).then(handleResponse);;
}

function getReservations() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/me/reservation`, requestOptions).then(handleResponse);
}

function deleteReservation(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/me/reservation/${id}`, requestOptions).then(handleResponse);
}

function patchReservation(id, res) {
  const requestOptions = {
    method: 'PATCH',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(res)
  };

  return fetch(`${config.apiUrl}/me/reservation/${id}`, requestOptions).then(handleResponse);
}

function postReservation(res) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(res)
  };

  return fetch(`${config.apiUrl}/me/reservation`, requestOptions).then(handleResponse);
}

function searchClients(search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/me/clients/${search}`, requestOptions).then(handleResponse);
}

function loadPlanning(date) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  const dateParams = date ? `/${date}` : '';

  return fetch(`${config.apiUrl}/me/planning${dateParams}`, requestOptions).then(handleResponse);
}

function loadCourts() {
  const requestOptions = {
    method: 'GET'
  };

  return fetch(`${config.apiUrl}/courts`, requestOptions).then(handleResponse);
}

function loadConfig() {
  const requestOptions = {
    method: 'GET'
  };

  return fetch(`${config.apiUrl}/config`, requestOptions).then(handleResponse);
}


function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        logout();
      }

      const error = data || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}